/* eslint-disable react/no-unknown-property */
/* eslint-disable import/no-unresolved */
/* eslint-disable max-len */
/* eslint-disable no-magic-numbers */
/* eslint-disable new-cap */
/* eslint-disable max-lines-per-function */

import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { AutoComplete as ChargeAutoComplete } from 'primereact/autocomplete';
import SearchIcon from '@material-ui/icons/Search';
import BackspaceIcon from '@material-ui/icons/Backspace';
import GetAppIcon from '@material-ui/icons/GetApp';
import ToggleButton from '@material-ui/lab/ToggleButton';
import CompareArrowsOutlinedIcon from '@material-ui/icons/CompareArrowsOutlined';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import Grid from '@material-ui/core/Grid';
import axios from 'axios';
import moment from 'moment';
import { ErrorMessage, Formik, Form, Field } from 'formik';
import { ProgressSpinner } from 'primereact/progressspinner';
import {
    showMessageSuccess,
    showMessageError,
    showMessageAlert
} from '../others/toastr';
import './style.css';
import { Card } from 'primereact/card';
import FundoAmarelo from '../../assets/fundo_amarelo.png';
import {
    BuscaPlanos,
    BuscarNomeCidades,
    estado
} from '../../modulos/function/tabelaPreco';
import { Dropdown } from 'primereact/dropdown';
import { savePromocao, UpdatePromocao, UpdatePromocaoMensalidade } from '../../services/tabelaPrecoApi/index';
import {
    useStyles,
    validations,
    initialValues,
    initialValuesEdit,
    ProdutoDescricaoBody,
    UpdateBody,
    CidadeBody,
    Estado,
    BuscaCidadeCodigo,
    ProdutoDescricaoSubGrupo,
    CarenciaBody,
    NovoBody,
    TrocaBody,
    ReabBody,
    valorBase,
    BuscaEstadoCodigo,
    validationsMensalidade,
    DescontoBody,
    calculaValorComDesconto,
    LoadingComponent,
    calculaValorComDescontoAdicionarAdesao,
    validationsEditarAdesao,
    valorComDescontoCartao,
    valorComDescontoBoleto,
    valorComDescontoEscelsa
} from '../../modulos/function/tabelaEdicaoPreco';
import { BuscarProduto } from '../../services/produtos';
import ModalLogEdicoes from '../logEdicaoTabelaPreco/index';
import ModalLogEdicoesMensalidade from '../logEdicaoTabelaPrecoMensalidade';
import CurrencyTextField from '../../modulos/mascaraMoeda/CurrencyTextField';
import { Checkbox, FormControlLabel, FormGroup, InputAdornment } from '@material-ui/core';
import { FiPercent } from 'react-icons/fi';
import { exportToCsv } from '../../modulos/excel/exportCsv';
import { limparDadosRelatorioTabelaPrecoAdesao } from '../../modulos/excel/tratamentoDadosRelatorios';
import { decriptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';
import { calculaValorFinal } from './ValorFinalDesconto';
import BodyModalEditMensalidade from './BodyModalEditMensalidade';
import BodyModalExclusaoDesconto from './bodyModalExclusaoDesconto';
import useNavegacao from '../../hooks/useNavegacao';
import { retornoHashValor } from '../../modulos/cripotografia/hash';
import { useHistory } from 'react-router-dom';

const TabelaEdicaoPreco = () => {
    const { navegarParaCadastroAdesaoEmLote, navegarParaCadastroMensalidadeEmLote } = useNavegacao();
    const header = <img alt="Card" src={FundoAmarelo} />;
    const [loading, setLoading] = useState(false);
    const [loadingChangeStatus, setLoadingChangeStatus] = useState(false);
    const [loadingUpdate, setLoadingUpdate] = useState(false);
    const [loadingRelatorioAdesao, setLoadingRelatorioAdesao] = useState(false);
    const [loadingTabela, setLoadingTabela] = useState(false);
    const classes = useStyles();
    const [sugestaoCidade, setSugestaoCidade] = useState([]);
    const [open, setOpen] = useState(false);
    const [dt, setDt] = useState(false);
    const [loandRMes, setLoandRMes] = useState(false);
    const [dados, setDados] = useState(false);
    const [openAdic, setOpenAdic] = useState(false);
    const [infoModal, setInfoModal] = useState(false);
    const [infApi, setInfApi] = useState([]);
    const [adicaoUf, setAdicaoUf] = useState('');
    const [getPromocao, setGetPromocao] = useState([]);
    const [valueCidade, setValueCidade] = useState(null);
    const [isSubGrupo, setSubGrupos] = useState(null);
    const [cidade, setCidade] = useState('');
    const [ocultarBotaoCidade, setOcultarBotaoCidade] = useState(false);
    const dataAtual = moment().format('YYYY-MM-DD HH:mm:ss');
    const IdUsuario = decriptoLocalStorage('IDuser').decriptoValue;
    const [arrayCidade, setArrayCidade] = useState([]);
    const [ufSelecionado, setUfSelecionado] = useState();
    const [valuesPlano, setValuesplano] = useState([]);
    const [tabela, setTabela] = useState('Adesao');
    const [openModal, setOpenModal] = useState(false);
    const [mostrarBotaoAbono, setMostrarBotaoAbono] = useState(false);

    const [paginaDeBusca, setPaginaDeBusca] = useState(1);
    const [paginaAtualDataTable, setPaginaAtualDataTable] = useState(0);
    const [paginasTotaisDataTable, setPaginasTotaisDataTable] = useState(0);
    const [itensPorPaginaDataTable, setItensPorPaginaDataTable] = useState(10);
    const [primeiroItenParaMostrarDataTable, setPrimeiroItenParaMostrarDataTable] = useState(0);
    const [paginaAnterior, setPaginaAnterior] = useState(0);
    const [naoPossuiMaisRegistros, setNaoPossuiMaisRegistros] = useState(false);
    const history = useHistory();

    let codigoCidade;
    const api = axios.create({
        baseURL: retornoHashValor(process.env.REACT_APP_1)
    });
    const defaultProps = {
        options: infApi,
        getOptionLabel: option => option.nome
    };

    const defaultPropsEstado = {
        options: estado,
        getOptionLabel: option => option.label
    };

    useEffect(() => {
        async function listar() {
            await api
                .get(
                    `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${adicaoUf}/municipios`
                )
                .then(resp => {
                    setInfApi(resp.data);
                })
                .catch(err => {
                    showMessageError('Erro ao buscar os municipios!');
                    console.log(err);
                });
        }

        listar();
    }, [adicaoUf]);

    useEffect(() => {
        if (paginaAtualDataTable !== 0 && paginaAnterior !== paginaAtualDataTable && paginaAtualDataTable === paginasTotaisDataTable) {
            getPromo(paginaDeBusca);
        }
    }, [paginaAtualDataTable]);

    async function verificaCidade(value) {
        setValueCidade(String(value?.id));
    }

    const limpaHooks = () => {
        setUfSelecionado();
        setAdicaoUf();
        setArrayCidade([]);
        setCidade();
        setTabela(tabela);
        setGetPromocao([]);
    };

    useEffect(() => {
        (async () => {
            try {
                await BuscarProduto().then(response => {
                    if (response) {
                        response.forEach(element => {
                            element.label = element.descricao;
                            element.value = element.SubGrupo;
                        });
                        setSubGrupos(response);
                    }
                });
            } catch (error) {
                return error;
            }
        })();
    }, [infoModal]);

    async function getCity() {
        if (cidade.length > 2) {
            const resultCidades = await BuscarNomeCidades(cidade, setArrayCidade, tabela);

            setSugestaoCidade(resultCidades.cidadeUf);
            setLoading(false);
        }
    }

    const removeInativo = tabelaPreco => tabelaPreco.filter(plano => plano.status !== false);

    async function getTablePricePlanoMens() {
        setLoandRMes(true);

        const resultPlano = await BuscaPlanos(
            ufSelecionado,
            arrayCidade,
            cidade,
            'Plano'
        );

        setValuesplano(resultPlano);
        exportCSVPlano();
    }

    async function getTablePricePlanoAdesao() {
        setLoadingRelatorioAdesao(true);

        const adesaoReport = await BuscaPlanos(
            ufSelecionado,
            arrayCidade,
            cidade,
            'Adesao'
        );
        const cabecalho = ['Plano', 'Cidade', 'UF', 'Carência', 'Novo', 'Desconto', 'Troca', 'Reabilitação'];
        const dadosTratadosParaExportacao = await limparDadosRelatorioTabelaPrecoAdesao(adesaoReport);

        const linhas = [cabecalho, ...dadosTratadosParaExportacao];

        await exportToCsv(`Relatorio_preços_adesão ${String(new Date().toLocaleDateString('pt-BR'))}`, linhas);
        setLoadingRelatorioAdesao(false);
    }

    async function getPromo(paginaDeBuscaQuery) {
        try {
            setLoadingTabela(true);

            if (paginaDeBuscaQuery !== 1 && naoPossuiMaisRegistros) {
                return;
            }

            let tipoTabela;

            if (tabela === 'Mensalidade') {
                tipoTabela = 'Plano';
            } else if (tabela === 'Adesao') {
                tipoTabela = 'Adesao';
            }

            const resultPlano = await BuscaPlanos(
                ufSelecionado,
                arrayCidade,
                cidade,
                tipoTabela,
                paginaDeBuscaQuery
            );

            const resultPlanoFiltrosInativos = removeInativo(resultPlano);

            if (!resultPlanoFiltrosInativos || typeof resultPlanoFiltrosInativos === 'string') {
                switch (paginaDeBuscaQuery) {
                    case 1:
                        showMessageAlert('', 'Planos não encontrado nesse Estado/cidade!');
                        break;

                    default:
                        setNaoPossuiMaisRegistros(true);
                        break;
                }

                return;
            }

            switch (paginaDeBuscaQuery) {
                case 1:
                    showMessageSuccess('', 'Busca realizada!');
                    setGetPromocao(resultPlanoFiltrosInativos);
                    break;

                default:
                    setGetPromocao(prev => [...prev, ...resultPlanoFiltrosInativos]);
                    break;
            }

            setNaoPossuiMaisRegistros(false);
            setPaginaDeBusca(paginaDeBuscaQuery + 1);
        } catch (error) {
            setLoadingTabela(false);
            showMessageError('Erro ao buscar planos, tente novamente mais tarde');

            return error;
        } finally {
            setLoadingTabela(false);
        }
    }

    let buscarCidade;
    let buscarUf;
    let buscarMacroReg;

    if (getPromocao.length > 0) {
        codigoCidade = getPromocao[0].cidade;
        buscarCidade = getPromocao[0]['CidadesIBGE.NOME'];
        buscarMacroReg = getPromocao[0]['macro_regiao'];

        const idUf = getPromocao[0]['UF'];

        estado.filter(item => {
            if (item.value == idUf) { buscarUf = item.value; }
        });
    }

    const handleClose = () => {
        setOpen(false);
        setOpenAdic(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    function modalExclusao(ev) {
        setOpenModal(true);
        setInfoModal(ev);
    }

    function handleCloseModalExclusao() {
        setOpenModal(false);
    }

    const exportCSV = () => {
        dt.exportCSV();
    };

    const exportCSVPlano = () => {
        dados.exportCSV();
        showMessageSuccess(
            'Sucesso',
            'Arquivo baixado'
        );
        setLoandRMes(false);
    };

    async function changeStatusPlano(rowData) {
        const newStatus = rowData.status ? 0 : 1;

        try {
            setLoadingChangeStatus(true);

            const dataChangeStatus = {
                cidade: rowData.cidade,
                plano: rowData.subgrupo.trim()
            };

            showMessageSuccess('', `Plano ${newStatus === 1 ? 'ativado' : 'desativado'} com sucesso!`);
            setTimeout(() => {
                handleClose();
                BuscaCidadeCodigo(codigoCidade, setGetPromocao, 'Adesao');
            }, 200);
            setPaginaDeBusca(1);
        } catch (error) {
            showMessageError('OPS', `Erro ao ${newStatus === 1 ? 'ativar' : 'desativar'} Adesão!`);
        } finally {
            setLoadingChangeStatus(false);
        }
    }

    async function onSubmit(values) {
        try {
            setLoadingUpdate(true);

            if (tabela === 'Adesao') {
                let adesao_novo, adesao_troca, adesao_reab;

                { typeof values.adesao_novo === 'string' ? adesao_novo = parseFloat(values.adesao_novo.replace('.', '').replace(',', '.')) : adesao_novo = values.adesao_novo; }

                { typeof values.adesao_troca === 'string' ? adesao_troca = parseFloat(values.adesao_troca.replace('.', '').replace(',', '.')) : adesao_troca = values.adesao_troca; }

                { typeof values.adesao_reab === 'string' ? adesao_reab = parseFloat(values.adesao_reab.replace('.', '').replace(',', '.')) : adesao_reab = values.adesao_reab; }

                const dataEdicao = {
                    id: infoModal.id,
                    cidade: infoModal['cidade'],
                    macro_regiao: infoModal.macro_regiao,
                    subgrupo: infoModal.subgrupo.trim(),
                    ufEstado: infoModal.UF,
                    carencia: values.carencia,
                    adesao_novo,
                    adesao_troca,
                    adesao_reab,
                    adesao_cremacao: values.adesao_cremacao,
                    dataUpdate: values.dataUpdate,
                    userUpdated: values.userUpdated,
                    percentualDesconto: values.desconto
                };

                UpdatePromocao(dataEdicao)
                    .then(resp => {
                        if (codigoCidade !== null) {
                            showMessageSuccess('', 'Edição realizado com sucesso!');
                            setTimeout(() => {
                                handleClose();
                                BuscaCidadeCodigo(codigoCidade, setGetPromocao, 'Adesao');
                                setPaginaDeBusca(1);
                            }, 200);
                        } else if (dataEdicao.ufEstado !== undefined) {
                            setTimeout(() => {
                                handleClose();
                                BuscaEstadoCodigo(dataEdicao.ufEstado, setGetPromocao, 'Adesao');
                                setPaginaDeBusca(1);
                            }, 200);
                        } else {
                            setTimeout(() => {
                                handleClose();
                                BuscaCidadeCodigo(codigoCidade, setGetPromocao, 'Adesao');
                                setPaginaDeBusca(1);
                            }, 200);
                        }

                        setLoadingUpdate(false);
                    })
                    .catch(err => {
                        showMessageError('OPS', 'Erro ao editar Promoções ( Preços )!');
                        setLoadingUpdate(false);
                        console.error(err);
                    });
            } else if (tabela === 'Mensalidade') {
                const { dataInicioDesconto, dataFinalDesconto, pagamentoBoleto, pagamentoCartao, pagamentoEscelsa } = values;

                let valorBase;
                let valorDesconto;

                { typeof values.valorBase === 'string' ? valorBase = parseFloat(values.valorBase.replace('.', '').replace(',', '.')) : valorBase = values.valorBase; }

                { typeof values.valorDesconto === 'string' ? valorDesconto = parseFloat(values.valorDesconto.replace('.', '').replace(',', '.')) : valorDesconto = values.valorDesconto; }

                const formaPagamento = [];

                if (pagamentoBoleto) {
                    formaPagamento.push(1);
                }

                if (pagamentoCartao) {
                    formaPagamento.push(7);
                }

                if (pagamentoEscelsa) {
                    formaPagamento.push(8);
                }

                const objetoEdicao = {
                    Uf: infoModal.UF,
                    cidade: values.cidade,
                    dataUpdate: values.dataUpdate,
                    subgrupo: infoModal.subgrupo.trim(),
                    tipo: 'Plano',
                    userUpdated: values.userUpdated,
                    valorBase,
                    valorDesconto,
                    dataInicioDesconto: moment(dataInicioDesconto).utc(true).add(3, 'hours'),
                    dataFinalDesconto: moment(dataFinalDesconto).utc(true).add(3, 'hours'),
                    formaPagamento
                };

                UpdatePromocaoMensalidade(infoModal.id, objetoEdicao)
                    .then(resp => {
                        if (codigoCidade !== null) {
                            showMessageSuccess('', 'Edição realizada com sucesso!');
                            setTimeout(() => {
                                handleClose();
                                BuscaCidadeCodigo(codigoCidade, setGetPromocao, 'Plano');
                                setPaginaDeBusca(1);
                            }, 200);
                        } else if (infoModal.UF !== undefined) {
                            setTimeout(() => {
                                handleClose();
                                BuscaEstadoCodigo(infoModal.UF, setGetPromocao, 'Plano');
                                setPaginaDeBusca(1);
                            }, 200);
                        } else {
                            setTimeout(() => {
                                handleClose();
                                BuscaCidadeCodigo(codigoCidade, setGetPromocao, 'Plano');
                                setPaginaDeBusca(1);
                            }, 200);
                        }

                        setLoadingUpdate(false);
                    })
                    .catch(err => {
                        showMessageError('OPS', 'Erro ao editar Promoções ( Preços )!');
                        setLoadingUpdate(false);
                        console.error(err);
                    });
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handleSubmit = async values => {
        setLoadingUpdate(true);

        const { Plano, carenciaSemPro, Novo, Troca, Reab, desconto, valorDesconto,
            dataInicioDesconto, dataFinalDesconto, pagamentoCartao, pagamentoBoleto, pagamentoEscelsa } = values;

        const adesao_novo = parseFloat(Novo.replace('.', '').replace(',', '.'));
        const adesao_troca = parseFloat(Troca.replace('.', '').replace(',', '.'));
        const adesao_reab = parseFloat(Reab.replace('.', '').replace(',', '.'));
        const valorBase = parseFloat(values.Valor_base.replace('.', '').replace(',', '.'));
        const valorFinalComDesconto = parseFloat(valorDesconto.replace('.', '').replace(',', '.'));
        const formaPagamento = [];

        if (pagamentoBoleto) {
            formaPagamento.push(1);
        }

        if (pagamentoCartao) {
            formaPagamento.push(7);
        }

        if (pagamentoEscelsa) {
            formaPagamento.push(8);
        }

        if (tabela === 'Adesao') {
            const bodySubmit = {
                percentualDesconto: desconto ? desconto : null,
                cidade: valueCidade,
                subgrupo: Plano,
                carencia: carenciaSemPro,
                adesao_novo,
                adesao_troca,
                adesao_reab,
                Uf: adicaoUf.toUpperCase(),
                tipo: 'Adesao',
                dataInsert: dataAtual,
                dataUpdate: dataAtual,
                userCreated: IdUsuario,
                userUpdated: IdUsuario
            };

            if (!bodySubmit.percentualDesconto) {
                delete bodySubmit.percentualDesconto;
            }

            savePromocao(bodySubmit)
                .then(response => {
                    if (response.status == 202) {
                        showMessageError('OPS', 'Cidade já cadastrada com este plano!');
                        handleClose();
                    } else if (response) {
                        showMessageSuccess('', 'Cadastro realizado com sucesso!');
                        handleClose();
                    }

                    setLoadingUpdate(false);
                })
                .catch(err => {
                    console.error(err);
                    showMessageError('OPS', 'Erro ao cadastrar preço e promoção!');
                    setLoadingUpdate(false);
                });
        } else if (tabela === 'Mensalidade') {
            const objetoEdicao = {
                subgrupo: Plano,
                Uf: adicaoUf.toUpperCase(),
                tipo: 'Plano',
                dataUpdate: dataAtual,
                userUpdated: IdUsuario,
                valorBase,
                cidade: valueCidade,
                valorDesconto: valorFinalComDesconto,
                dataInicioDesconto: dataInicioDesconto === '' ? null : moment(dataInicioDesconto).utc(true).add(3, 'hours'),
                dataFinalDesconto: dataFinalDesconto === '' ? null : moment(dataFinalDesconto).utc(true).add(3, 'hours'),
                formaPagamento
            };

            savePromocao(objetoEdicao)
                .then(response => {
                    if (response.status == 202) {
                        showMessageError('OPS', 'Cidade já cadastrada com este plano!');
                        handleClose();
                    } else if (response) {
                        showMessageSuccess('', 'Cadastro realizado com sucesso!');
                        handleClose();
                    }

                    setLoadingUpdate(false);
                })
                .catch(err => {
                    showMessageError('OPS', 'Erro ao cadastrar preço e promoção!');
                    setLoadingUpdate(false);
                    console.error(err);
                });
        }
    };

    initialValuesEdit.carencia = infoModal.carencia;
    initialValuesEdit.adesao_novo = infoModal.adesao_novo;
    initialValuesEdit.adesao_troca = infoModal.adesao_troca;
    initialValuesEdit.adesao_reab = infoModal.adesao_reab;
    initialValuesEdit.adesao_cremacao = infoModal.adesao_cremacao;
    initialValuesEdit.dataUpdate = dataAtual;
    initialValuesEdit.userUpdated = infoModal.userUpdated;

    function dataModal(ev) {
        handleOpen(true);
        setInfoModal(ev);
    }

    function dataModalMensalidade(ev) {
        handleOpen(true);
        setInfoModal(ev);
    }

    function modalEdicao(rowData) {
        if (tabela === 'Adesao') {
            dataModal(rowData);
        } else if (tabela === 'Mensalidade') {
            dataModalMensalidade(rowData);
        }
    }

    function ButtonBodyTemplate(rowData) {
        const status = rowData.status ? 1 : 0;

        return (
            <div className='datatable-editar'>
                <Button variant="contained" color="primary" onClick={() => modalEdicao(rowData)}>
                    Editar
                </Button>
                {tabela === 'Mensalidade' && <>
                    <Button onClick={() => changeStatusPlano(rowData)} className='datatable-status' color="primary" >
                        <span>{status === 1 ? 'Desativar' : 'ativar'}</span>
                        <i className={`pi ${status ? 'pi-eye-slash' : 'pi-eye'} datatable-status-icone`} />
                    </Button>
                    <Button onClick={() => modalExclusao(rowData)} className='botao-excluir-desconto' color="primary" >
                        <span>Excluir Desconto</span>
                        <i className={'pi pi-trash'} />
                    </Button>
                </>}
            </div>
        );
    }

    function StatusBody(rowData) {
        const status = rowData.status ? 1 : 0;

        return (
            <React.Fragment>
                <div className='datatable-body'>
                    <span className="p-column-title">Status</span>
                    <div>
                        <span className="status" style={{ color: `${status ? 'green' : 'red'}` }}>{status === 1 ? 'ATIVADO' : 'DESATIVADO'}</span>
                    </div>
                </div>

            </React.Fragment>
        );
    }

    function ButtonLog(rowData) {
        if (tabela === 'Adesao') {
            return (
                <>
                    <ModalLogEdicoes id={rowData.id} />
                </>
            );
        } else if (tabela === 'Mensalidade') {
            return (
                <>
                    <ModalLogEdicoesMensalidade id={rowData.id} />
                </>
            );
        }
    }

    const renderizaTabelas = () => {
        switch (tabela) {
            case 'Adesao':
                return <>
                    {!loadingChangeStatus && <div className="datatable-responsive-demo">

                        <h1
                            style={{
                                marginTop: '50px'
                            }}
                        >Tabela de preço de Adesao</h1>
                        <br />
                        <div>
                            <DataTable
                                csvSeparator=";"
                                className="p-datatable-responsive-demo"
                                value={getPromocao}
                                ref={el => setDt(el)}
                                paginator={true}
                                loading={loadingTabela}
                                exportFilename={`${`Relatorio_preços_adesao ${String(new Date().toLocaleDateString('pt-BR'))}`
                                }`}
                                rowsPerPageOptions={[10, 20, 50]}
                                rows={itensPorPaginaDataTable}
                                onPage={e => {
                                    const paginaAtual = paginaAtualDataTable;

                                    setPrimeiroItenParaMostrarDataTable(e.first);
                                    setPaginaAtualDataTable(e.page);
                                    setPaginasTotaisDataTable(e.pageCount - 1);
                                    setItensPorPaginaDataTable(e.rows);
                                    setPaginaAnterior(paginaAtual);
                                }}
                                first={primeiroItenParaMostrarDataTable}
                            >
                                <Column
                                    field="Produto.descricao"
                                    header="Plano"
                                    body={ProdutoDescricaoBody}
                                    bodyStyle={{
                                        backgroundColor: '#B0E0E6',
                                        height: '60px'
                                    }}
                                ></Column>
                                {/* <Column
                        field="carencia_promocional"
                        header="Carência c/ Promoção"
                        body={CarenciaPromocionalBody}
                        bodyStyle={{ backgroundColor: '#E0FFFF' }}
                     ></Column> */}
                                <Column
                                    field="CidadesIBGE.NOME"
                                    header="Cidade"
                                    body={CidadeBody}
                                    bodyStyle={{ backgroundColor: '#E0FFFF' }}
                                ></Column>
                                <Column
                                    field="UF"
                                    header="UF"
                                    body={Estado}
                                    bodyStyle={{ backgroundColor: '#E0FFFF' }}
                                ></Column>
                                <Column
                                    field="carencia"
                                    header="Carência"
                                    body={CarenciaBody}
                                    bodyStyle={{ backgroundColor: '#e4d0e3' }}
                                ></Column>
                                <Column
                                    field="adesao_novo"
                                    header="Novo"
                                    body={NovoBody}
                                    bodyStyle={{ backgroundColor: '#e4d0e3' }}
                                ></Column>
                                <Column
                                    field="percentualDesconto"
                                    header="Desconto"
                                    body={DescontoBody}
                                    bodyStyle={{ backgroundColor: '#e4d0e3' }}
                                ></Column>
                                <Column
                                    field="adesao_troca"
                                    header="Troca"
                                    body={TrocaBody}
                                    bodyStyle={{ backgroundColor: '#e4d0e3' }}
                                ></Column>
                                <Column
                                    field="adesao_reab"
                                    header="Reabilitação"
                                    body={ReabBody}
                                    bodyStyle={{ backgroundColor: '#e4d0e3' }}
                                ></Column>
                                <Column
                                    field="userAccessCreated.AnalistaComercial.userCreated"
                                    headerStyle={{
                                        width: '9em'
                                    }}
                                    header="Editado por"
                                    body={UpdateBody}
                                    bodyStyle={{
                                        backgroundColor: '#e4d0e3',
                                        fontSize: '13px'
                                    }}
                                ></Column>
                                <Column
                                    field=""
                                    header="Ação"
                                    body={ButtonBodyTemplate}
                                    bodyStyle={{
                                        textAlign: 'center',
                                        backgroundColor: '#e4d0e3'
                                    }}
                                ></Column>
                                <Column
                                    field=""
                                    header="Registro de Edições"
                                    headerStyle={{
                                        width: '7em'
                                    }}
                                    body={ButtonLog}
                                    bodyStyle={{
                                        textAlign: 'center',
                                        backgroundColor: '#e4d0e3'
                                    }}
                                ></Column>
                            </DataTable>
                        </div>
                    </div>}
                    {
                        loadingChangeStatus && <div className='is-loading'>
                            <ProgressSpinner
                                strokeWidth="1"
                                fill="#EEEEEE"
                                animationDuration=".5s"
                            />
                        </div>
                    }
                </>;
            case 'Mensalidade':
                return (
                    <div className="datatable-responsive-demo">
                        <h1
                            style={{
                                marginTop: '50px'
                            }}
                        >
                            Tabela de preço de Mensalidade
                        </h1>
                        <br />
                        <div>
                            <DataTable
                                csvSeparator=";"
                                className="p-datatable-responsive-demo"
                                value={getPromocao}
                                ref={el => setDt(el)}
                                paginator={true}
                                loading={loadingTabela}
                                exportFilename={`${`Relatorio_preços_mensalidade ${String(new Date().toLocaleDateString('pt-BR'))}`
                                }`}
                                rowsPerPageOptions={[10, 20, 50]}
                                rows={itensPorPaginaDataTable}
                                onPage={e => {
                                    const paginaAtual = paginaAtualDataTable;

                                    setPrimeiroItenParaMostrarDataTable(e.first);
                                    setPaginaAtualDataTable(e.page);
                                    setPaginasTotaisDataTable(e.pageCount - 1);
                                    setItensPorPaginaDataTable(e.rows);
                                    setPaginaAnterior(paginaAtual);
                                }}
                                first={primeiroItenParaMostrarDataTable}

                            >
                                <Column
                                    field="Produto.descricao"
                                    header="Plano"
                                    body={ProdutoDescricaoBody}
                                    bodyStyle={{
                                        backgroundColor: '#B0E0E6',
                                        height: '60px'
                                    }}
                                ></Column>
                                <Column
                                    field="SubGrupo"
                                    header="Subgrupo"
                                    body={ProdutoDescricaoSubGrupo}
                                    bodyStyle={{
                                        backgroundColor: '#B0E0E6',
                                        height: '60px'
                                    }}
                                ></Column>
                                <Column
                                    field="CidadesIBGE.NOME"
                                    header="Cidade"
                                    body={CidadeBody}
                                    bodyStyle={{ backgroundColor: '#E0FFFF' }}
                                ></Column>
                                <Column
                                    field="UF"
                                    header="UF"
                                    body={Estado}
                                    bodyStyle={{ backgroundColor: '#E0FFFF' }}
                                ></Column>
                                <Column
                                    field="Status"
                                    header="Status"
                                    body={StatusBody}
                                    bodyStyle={{ backgroundColor: '#e4d0e3' }}
                                ></Column>
                                <Column
                                    field="valorBase"
                                    header="Valor Base"
                                    body={valorBase}
                                    bodyStyle={{
                                        textAlign: 'center',
                                        backgroundColor: '#e4d0e3'
                                    }}
                                >

                                </Column>
                                <Column
                                    field="valorDoDescontoCartao"
                                    header="Valor e vigência do desconto cartão"
                                    body={valorComDescontoCartao ? valorComDescontoCartao : '0'}
                                    bodyStyle={{
                                        textAlign: 'center',
                                        backgroundColor: '#e4d0e3'
                                    }}
                                >

                                </Column>
                                <Column
                                    field="valorDoDescontoBoleto"
                                    header="Valor e vigência do desconto boleto"
                                    body={valorComDescontoBoleto ? valorComDescontoBoleto : '0'}
                                    bodyStyle={{
                                        textAlign: 'center',
                                        backgroundColor: '#e4d0e3'
                                    }}
                                >

                                </Column>
                                <Column
                                    field="valorDoDescontoEscelsa"
                                    header="Valor e vigência do desconto Escelsa"
                                    body={valorComDescontoEscelsa ? valorComDescontoEscelsa : '0'}
                                    bodyStyle={{
                                        textAlign: 'center',
                                        backgroundColor: '#e4d0e3'
                                    }}
                                >

                                </Column>
                                <Column
                                    field="userAccessCreated.AnalistaComercial.userCreated"
                                    headerStyle={{
                                        width: '9em'
                                    }}
                                    header="Editado por"
                                    body={UpdateBody}
                                    bodyStyle={{
                                        backgroundColor: '#e4d0e3',
                                        fontSize: '13px'
                                    }}
                                ></Column>
                                <Column
                                    field=""
                                    header="Ação"
                                    body={ButtonBodyTemplate}
                                    bodyStyle={{
                                        textAlign: 'center',
                                        backgroundColor: '#e4d0e3'
                                    }}
                                ></Column>
                                <Column
                                    field=""
                                    header="Registro de Edições"
                                    headerStyle={{
                                        width: '7em'
                                    }}
                                    body={ButtonLog}
                                    bodyStyle={{
                                        textAlign: 'center',
                                        backgroundColor: '#e4d0e3'
                                    }}
                                ></Column>
                            </DataTable>
                        </div>
                    </div>);
            default:
                return <h4>Selecione alguma tabela</h4>;
        }
    };

    const adicionandoPlanoAdesao = () => (
        <div className="ModalStyle PaperModal">
            <Typography variant="h6" gutterBottom>
                Cadastro de Preço de Adesao
            </Typography>
            {!loadingUpdate && <div className="dentroModal">
                <Formik
                    onSubmit={handleSubmit}
                    initialValues={initialValues}
                    validationSchema={validations}
                >
                    {({ values, handleSubmit, handleChange }) => (
                        <>
                            <Form>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={12}>
                                        <Field
                                            as={Dropdown}
                                            value={values.Plano}
                                            name="Plano"
                                            id="Plano"
                                            onChange={handleChange}
                                            options={isSubGrupo}
                                            placeholder="Selecione o Plano"
                                            variant="standard"
                                        />
                                        <ErrorMessage
                                            component="span"
                                            name="Plano"
                                            style={{ color: 'red' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Autocomplete
                                            {...defaultPropsEstado}
                                            id="uf"
                                            nome="uf"
                                            onChange={(ev, value) => ev && setAdicaoUf(value.value)}
                                            renderInput={params => (
                                                <TextField {...params} label="UF" />
                                            )}
                                            style={{ width: '100%' }}
                                        />
                                        <ErrorMessage component="span" name="uf" style={{ color: 'red' }} />
                                    </Grid>
                                    {ocultarBotaoCidade && (
                                        <Grid item xs={12} sm={4}>
                                            <Autocomplete
                                                {...defaultProps}
                                                id="cidade"
                                                nome="cidade"
                                                cidade
                                                onChange={(ev, value) => {
                                                    ev && verificaCidade(value);
                                                }}
                                                renderInput={params => (
                                                    <TextField {...params} label="Cidade" />
                                                )}
                                                style={{ width: '100%' }}
                                            />
                                            <ErrorMessage
                                                component="span"
                                                name="cidade"
                                                style={{ color: 'red' }}
                                            />
                                        </Grid>
                                    )}
                                    <Grid item xs={12} sm={4}>
                                        <Field
                                            id="carenciaSemPro"
                                            name="carenciaSemPro"
                                            onChange={handleChange}
                                            type="number"
                                            label="Carência"
                                            component={TextField}
                                            style={{ width: '100%' }}
                                        />
                                        <ErrorMessage
                                            component="span"
                                            name="carenciaSemPro"
                                            style={{ color: 'red' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <CurrencyTextField
                                            label="Novo"
                                            id="Novo"
                                            name="Novo"
                                            variant="standard"
                                            currencySymbol="R$"
                                            onChange={handleChange}
                                            decimalCharacter=","
                                            digitGroupSeparator="."
                                            TextField
                                            style={{ width: '100%' }}
                                        />
                                        <ErrorMessage
                                            component="span"
                                            name="Novo"
                                            style={{ color: 'red' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Field
                                            label='Desconto'
                                            name='desconto'
                                            id='desconto'
                                            onChange={handleChange}
                                            type="number"
                                            pattern="[0-9]+([,.][0-9]+)?"
                                            min="0"
                                            step="any"
                                            max="99"
                                            component={TextField}
                                            decimalCharacter=","
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <i class="pi pi-percentage" style={{
                                                            fontSize: '1em',
                                                            color: '#707070'
                                                        }} />
                                                    </InputAdornment>
                                                )
                                            }}
                                            style={{ width: '100%' }}
                                        />

                                        <ErrorMessage
                                            component="span"
                                            name="desconto"
                                            style={{ color: 'red' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        {calculaValorComDescontoAdicionarAdesao(values)}
                                        <CurrencyTextField
                                            value={values.valorComDesconto}
                                            disabled
                                            placeholder='valor com desconto'
                                            label="valor com desconto"
                                            id="valoComDesconto"
                                            name="valoComDesconto"
                                            variant="standard"
                                            currencySymbol="R$"
                                            decimalCharacter=","
                                            digitGroupSeparator="."
                                            style={{ width: '100%' }}
                                        />

                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <CurrencyTextField
                                            label="Troca"
                                            id="Troca"
                                            name="Troca"
                                            variant="standard"
                                            currencySymbol="R$"
                                            onChange={handleChange}
                                            decimalCharacter=","
                                            digitGroupSeparator="."
                                            style={{ width: '100%' }}
                                        />
                                        <ErrorMessage
                                            component="span"
                                            name="Troca"
                                            style={{ color: 'red' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <CurrencyTextField
                                            label="Reabilitação"
                                            id="Reab"
                                            name="Reab"
                                            variant="standard"
                                            currencySymbol="R$"
                                            outputFormat="string"
                                            onChange={handleChange}
                                            decimalCharacter=","
                                            digitGroupSeparator="."
                                            style={{ width: '100%' }}
                                        />
                                        <ErrorMessage
                                            component="span"
                                            name="Reab"
                                            style={{ color: 'red' }}
                                        />
                                    </Grid>
                                </Grid>
                                <Button
                                    className={classes.buttons}
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSubmit}
                                >
                                    Salvar
                                </Button>
                            </Form>
                        </>
                    )}
                </Formik>
            </div>}
            {loadingUpdate && <LoadingComponent />}
        </div>
    );

    const adicionandoPlanoMensalidade = () => (
        <div className="ModalStyle PaperModal">
            <Typography variant="h6" gutterBottom>
                Cadastro de Preço de Mensalidade
            </Typography>
            <div className="dentroModal">
                <Formik
                    onSubmit={handleSubmit}
                    initialValues={initialValues}
                    validationSchema={validationsMensalidade}
                >
                    {({ values, handleSubmit, handleChange, setFieldValue }) => (
                        <>
                            <Form>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={12}>
                                        <Field
                                            as={Dropdown}
                                            value={values.Plano}
                                            name="Plano"
                                            id="Plano"
                                            onChange={handleChange}
                                            options={isSubGrupo}
                                            placeholder="Selecione o Plano"
                                            variant="standard"
                                        />
                                        <ErrorMessage
                                            component="span"
                                            name="Plano"
                                            style={{ color: 'red' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Autocomplete
                                            {...defaultPropsEstado}
                                            id="uf"
                                            nome="uf"
                                            onChange={(ev, value) => ev && setAdicaoUf(value.value)}
                                            renderInput={params => (
                                                <TextField {...params} label="UF" />
                                            )}
                                            style={{ width: '100%' }}
                                        />
                                        <ErrorMessage component="span" name="uf" style={{ color: 'red' }} />
                                    </Grid>
                                    {ocultarBotaoCidade && (
                                        <Grid item xs={12} sm={4}>
                                            <Autocomplete
                                                {...defaultProps}
                                                id="cidade"
                                                nome="cidade"
                                                cidade
                                                onChange={(ev, value) => ev && verificaCidade(value)}
                                                renderInput={params => (
                                                    <TextField {...params} label="Cidade" />
                                                )}
                                                style={{ width: '100%' }}
                                            />
                                            <ErrorMessage
                                                component="span"
                                                name="cidade"
                                                style={{ color: 'red' }}
                                            />
                                        </Grid>
                                    )}
                                    <Grid item xs={12} sm={4}>
                                        <CurrencyTextField
                                            label="Valor Base"
                                            id="Valor_base"
                                            name="Valor_base"
                                            variant="standard"
                                            currencySymbol="R$"
                                            onChange={e => { handleChange(e); setFieldValue('valorFinal', calculaValorFinal(values.Valor_base, values?.valorDesconto)); }}
                                            decimalCharacter=","
                                            digitGroupSeparator="."
                                            style={{ width: '100%' }}
                                        />
                                        <ErrorMessage
                                            component="span"
                                            name="Valor_base"
                                            style={{ color: 'red' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Field
                                            as={TextField}
                                            id="dataInicioDesconto"
                                            label="Data inicio desconto"
                                            type="date"
                                            className={classes.textField}
                                            style={{ width: '100%' }}
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            onChange={handleChange}
                                            value={values.dataInicioDesconto}
                                        />
                                        <ErrorMessage
                                            component="span"
                                            name="dataInicioDesconto"
                                            style={{ color: 'red' }}
                                        />

                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Field
                                            as={TextField}
                                            id="dataFinalDesconto"
                                            label="Data final desconto"
                                            type="date"
                                            style={{ width: '100%' }}

                                            className={classes.textField}
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            onChange={handleChange}
                                            value={values.dataFinalDesconto}

                                        />
                                        <ErrorMessage
                                            component="span"
                                            name="dataFinalDesconto"
                                            style={{ color: 'red' }}
                                        />

                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <CurrencyTextField
                                            label="Valor do desconto"
                                            id="valorDesconto"
                                            name="valorDesconto"
                                            variant="standard"
                                            currencySymbol="R$"
                                            onChange={e => {
                                                handleChange(e);
                                                setFieldValue('valorFinal', calculaValorFinal(values.Valor_base, values?.valorDesconto));
                                            }}
                                            decimalCharacter=","
                                            digitGroupSeparator="."
                                            style={{ width: '100%' }}

                                        />
                                        <ErrorMessage
                                            component="span"
                                            name="valorDesconto"
                                            style={{ color: 'red' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormGroup
                                            row={true}>
                                            <FormControlLabel
                                                control={<Checkbox color='primary' />}
                                                label="Cartão"
                                                value={values.pagamentoCartao}
                                                id='pagamentoCartao'
                                                name='pagamentoCartao'
                                                onChange={handleChange} />
                                            <FormControlLabel
                                                control={<Checkbox color='primary' />}
                                                label="Boleto"
                                                value={values.pagamentoBoleto}
                                                id='pagamentoBoleto'
                                                name='pagamentoBoleto'
                                                onChange={handleChange} />
                                            {adicaoUf === 'ES' && <>
                                                <FormControlLabel
                                                    control={<Checkbox color='primary' />}
                                                    label="Escelsa"
                                                    value={values.pagamentoEscelsa}
                                                    id='pagamentoEscelsa'
                                                    name='pagamentoEscelsa'
                                                    onChange={handleChange} />
                                            </>}
                                        </FormGroup>
                                        <ErrorMessage
                                            component="span"
                                            name="formasPagamento"
                                            style={{ color: 'red' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <CurrencyTextField
                                            label="Valor Final"
                                            id="valorFinal"
                                            name="valorFinal"
                                            variant="standard"
                                            currencySymbol="R$"
                                            onChange={handleChange}
                                            decimalCharacter=","
                                            digitGroupSeparator="."
                                            style={{ width: '100%' }}
                                            disabled={true}
                                            value={values.valorFinal}

                                        />

                                    </Grid>
                                </Grid>
                                <Button
                                    className={classes.buttons}
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSubmit}
                                >
                                    Salvar
                                </Button>
                            </Form>
                        </>
                    )}
                </Formik>
            </div>
        </div>
    );

    const bodyModalAdesao = () => (
        <div className="ModalStyle PaperModal1">
            <Typography variant="h6" gutterBottom>
                Edição de Preço de Adesao
            </Typography>
            {<div className="dentroModalEdicao">
                {!loadingUpdate && infoModal && (
                    <>
                        <Formik
                            onSubmit={onSubmit}
                            initialValues={{
                                ...initialValuesEdit,
                                desconto: infoModal.percentualDesconto || 0
                            }}
                            validationSchema={validationsEditarAdesao}
                        >
                            {({ handleChange, setFieldValue, onSubmit, values }) => (
                                <>

                                    <Form>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} sm={6}>
                                                <Field
                                                    style={{ width: '100%' }}
                                                    id="carencia"
                                                    name="carencia"
                                                    defaultValue={infoModal.carencia}
                                                    label="Carência"
                                                    onChange={handleChange}

                                                    type="number"
                                                    component={TextField}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <CurrencyTextField
                                                    style={{ width: '100%' }}
                                                    label="Novo"
                                                    id="adesao_novo"
                                                    name="adesao_novo"
                                                    defaultValue={infoModal.adesao_novo}
                                                    variant="standard"
                                                    currencySymbol="R$"
                                                    onChange={handleChange}
                                                    decimalCharacter=","
                                                    digitGroupSeparator="."
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <CurrencyTextField
                                                    style={{ width: '100%' }}
                                                    label="Troca"
                                                    id="adesao_troca"
                                                    name="adesao_troca"
                                                    defaultValue={infoModal.adesao_troca}
                                                    variant="standard"
                                                    currencySymbol="R$"
                                                    onChange={handleChange}
                                                    decimalCharacter=","
                                                    digitGroupSeparator="."
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <CurrencyTextField
                                                    style={{ width: '100%' }}
                                                    label="Reabilitação"
                                                    id="adesao_reab"
                                                    name="adesao_reab"
                                                    defaultValue={infoModal.adesao_reab}
                                                    variant="standard"
                                                    currencySymbol="R$"
                                                    onChange={handleChange}
                                                    decimalCharacter=","
                                                    digitGroupSeparator="."
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <label style={{
                                                    color: 'grey',
                                                    fontSize: 'small'
                                                }}>Desconto</label>
                                                <div style={{ display: 'flex' }}>
                                                    <FiPercent style={{
                                                        height: '1.85rem',
                                                        color: ' gray',
                                                        borderBottom: '1px solid gray'
                                                    }} />
                                                    <input
                                                        label='desconto'
                                                        name='desconto'
                                                        id='desconto'
                                                        onChange={handleChange}
                                                        defaultValue={infoModal.percentualDesconto || 0}
                                                        pattern="[0-9]+([,.][0-9]+)?"
                                                        type="number"
                                                        min="0"
                                                        step="any"
                                                        max="99"
                                                        decimalCharacter=","
                                                        component={TextField}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <i class="pi pi-percentage" style={{
                                                                        fontSize: '1em',
                                                                        color: '#707070'
                                                                    }} />
                                                                </InputAdornment>
                                                            )
                                                        }}
                                                        style={{
                                                            borderBottom: '1px solid gray',
                                                            borderTop: 'none',
                                                            borderRight: 'none',
                                                            borderLeft: 'none',
                                                            width: '100%',
                                                            height: '1.85rem',
                                                            textAlign: 'end',
                                                            fontSize: 'initial'
                                                        }}
                                                    />
                                                    <ErrorMessage component="span" name="desconto" style={{ color: 'red' }} />
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                {calculaValorComDesconto(values)}
                                                <CurrencyTextField
                                                    style={{ width: '100%' }}
                                                    value={values.valorComDesconto}
                                                    disabled
                                                    placeholder='valor com desconto'
                                                    label="valor com desconto"
                                                    id="valoComDesconto"
                                                    name="valoComDesconto"
                                                    defaultValue={infoModal.valoComDesconto}
                                                    variant="standard"
                                                    currencySymbol="R$"
                                                    decimalCharacter=","
                                                    digitGroupSeparator="."
                                                />

                                            </Grid>
                                        </Grid>
                                        <Button
                                            className={classes.buttons}
                                            variant="contained"
                                            color="primary"
                                            type="submit"
                                            onClick={() => setFieldValue(onSubmit)}
                                        >
                                            Salvar
                                        </Button>
                                    </Form>
                                </>
                            )}
                        </Formik>
                    </>
                )}
                {loadingUpdate &&
                    <LoadingComponent />
                }

            </div>}
        </div>
    );

    return (
        <div className="paper">
            <Card className='tratar-scroll-card' header={header} >
                <h2>{`Editar Tabela de Preços de ${tabela}`}</h2>
                <div className="buttonDiv">
                    <div className="buttonDivToggle">
                        <p>Trocar formulário:</p>
                        <ToggleButton
                            value={tabela}
                            style={{
                                margin: '6px 0',
                                color: '#101C85',
                                borderColor: '#101C85'
                            }}
                            onChange={(event, novoValor) => {
                                if (novoValor === 'Adesao') {
                                    setTabela('Mensalidade');
                                    setMostrarBotaoAbono(true);
                                } else {
                                    setTabela('Adesao');
                                    setMostrarBotaoAbono(false);
                                }

                                setGetPromocao([]);
                                setPaginaDeBusca(1);
                            }}
                        >
                            {tabela}
                            <CompareArrowsOutlinedIcon />
                        </ToggleButton>
                    </div>

                    <div className="buttonDivC">

                        {tabela === 'Adesao' && <Button
                            variant="contained"
                            className='botoes'
                            color="primary"
                            onClick={navegarParaCadastroAdesaoEmLote}
                        >
                            {'Adicionar / Editar Adesao em lote'}
                        </Button>}
                        {tabela === 'Mensalidade' && <Button
                            variant="contained"
                            className='botoes'
                            color="primary"
                            onClick={navegarParaCadastroMensalidadeEmLote}
                        >
                            {'Adicionar / Editar Mensalidade em lote'}
                        </Button>}
                        {mostrarBotaoAbono && (
                            <Button
                                variant="contained"
                                className='botaoAbono'
                                onClick={() => history.push('/bonificacao')}
                            >
                                Bonificação de mensalidades
                            </Button>
                        )}
                    </div>
                    <div className="buttonDivC">
                        <Button
                            variant="contained"
                            className='botoes'
                            onClick={exportCSV}
                            disabled={getPromocao.length == 0}
                            endIcon={<GetAppIcon />}
                            style={getPromocao.length !== 0 ? {
                                background: 'green',
                                color: 'white'
                            } : {}}
                        >
                            {`Baixar CSV da Tabela ${tabela}`}
                        </Button>
                        <Button
                            variant="contained"
                            onClick={getTablePricePlanoMens}
                            placeholder="Gerar CSV"
                            className='botoes'
                            style={{
                                background: 'green',
                                color: 'white'
                            }}
                            endIcon={<GetAppIcon />}
                        >
                            {!loandRMes ? 'Relatorio Valores Mensalidade' : 'Carregando...'}
                        </Button>
                        <Button
                            variant="contained"
                            onClick={getTablePricePlanoAdesao}
                            placeholder="Gerar CSV"
                            className='botoes'
                            style={{
                                background: 'green',
                                color: 'white'
                            }}
                            endIcon={<GetAppIcon />}
                        >
                            {!loadingRelatorioAdesao ? 'Relatorio Valores Adesão' : 'Carregando...'}
                        </Button>
                    </div>
                    <DataTable
                        exportFilename={`${`Relatorio_preços_mesalidade ${String(new Date().toLocaleDateString('pt-BR'))}`}`}
                        style={{ display: 'none' }}
                        csvSeparator=";"
                        value={valuesPlano}
                        ref={el => setDados(el)}
                    >
                        <Column field="Produto.descricao" header="Plano"></Column>
                        <Column field="valorBase" header="valorBase"></Column>
                        <Column field="Produto.valor" header="Valor"></Column>
                        <Column field="CidadesIBGE.NOME" header="Cidade"></Column>
                        <Column field="macro_regiao" header="Macro Região"></Column>
                        <Column field="UF" header="UF"></Column>
                        <Column field="subgrupo" header="subgrupo"></Column>
                    </DataTable>
                </div>
                <div activeStep="2" className={classes.stepper}>
                    <div className="contai">
                        <div className={classes.input}>
                            <label className={classes.label}>
                                Digite o nome da Cidade:
                                <div className={classes.Autocomplete}>
                                    <ChargeAutoComplete
                                        completeMethod={getCity}
                                        optionGroupLabel="label"
                                        suggestions={sugestaoCidade}
                                        value={cidade}
                                        id="cidade"
                                        onChange={e => setCidade(e.target.value)}
                                    />
                                </div>
                            </label>
                            <Dropdown
                                value={ufSelecionado}
                                name="UF"
                                id="UF"
                                onChange={e => setUfSelecionado(e.value)}
                                options={estado}
                                placeholder="UF"
                                style={{
                                    margin: '0 4px'
                                }}
                            />

                        </div>
                    </div>
                </div>
                <Button
                    onClick={() => {
                        setPaginaDeBusca(1);
                        getPromo(1);
                    }}
                    endIcon={<SearchIcon />}
                    placeholder="Pesquisar"
                    variant="contained"
                    className={classes.buttonSearch}
                    color="primary"
                >
                    Pesquisar
                </Button>
                <Button
                    onClick={limpaHooks}
                    placeholder="Limpar"
                    variant="outlined"
                    className={classes.buttonSearch}
                    color="primary"
                    endIcon={<BackspaceIcon />}
                >
                    Limpar
                </Button>
                {loading && (
                    <ProgressSpinner
                        style={{
                            width: '100px',
                            height: '100px'
                        }}
                        strokeWidth="1"
                        fill="#EEEEEE"
                        animationDuration=".5s"
                    />
                )}
                <Modal
                    open={open}
                    onClose={handleClose}
                    disableEnforceFocus
                    aria-labelledby="server-modal-title"
                    aria-describedby="server-modal-description"
                >
                    <div>{tabela === 'Adesao' ? bodyModalAdesao() : <BodyModalEditMensalidade
                        infoModal={infoModal}
                        onSubmit={onSubmit}
                        classes={classes} />} </div>
                </Modal>
                <Modal
                    open={openModal}
                    onClose={handleCloseModalExclusao}
                    disableEnforceFocus
                    aria-labelledby="server-modal-title"
                    aria-describedby="server-modal-description"
                >
                    <div>
                        <BodyModalExclusaoDesconto
                            openModal={openModal}
                            setOpenModal={setOpenModal}
                            rowData={infoModal}
                            classes={classes}
                            setGetPromocao={setGetPromocao}
                            codigoCidade={codigoCidade}></BodyModalExclusaoDesconto>
                    </div>
                </Modal>
                <Modal
                    open={openAdic}
                    onClose={handleClose}
                    disableEnforceFocus
                    aria-labelledby="server-modal-title"
                    aria-describedby="server-modal-description"
                >
                    <div>{tabela === 'Adesao' ? adicionandoPlanoAdesao() : adicionandoPlanoMensalidade()}</div>
                </Modal>
                {renderizaTabelas()}
            </Card>
        </div>
    );
};

export default TabelaEdicaoPreco;
